import { io } from "socket.io-client";

import { API_URL } from "src/Common/function";
import TokenService from "src/Services/API/token.service";

let timeOffSocket;

const getTimeOffSocket = () => {
  if (!timeOffSocket) {
    timeOffSocket = io(API_URL, {
      autoConnect: false,
      transports: ["websocket"],
    });
  }

  return timeOffSocket;
};

const connectTimeOffSocket = () => {
  const socket = getTimeOffSocket();
  socket.auth = {
    token: TokenService.getLocalAccessToken(),
  };

  if (!socket.connected) {
    socket.connect();
  }

  return socket;
};

const disconnectTimeOffSocket = () => {
  if (timeOffSocket?.connected) {
    timeOffSocket.disconnect();
  }
};

export { getTimeOffSocket, connectTimeOffSocket, disconnectTimeOffSocket };
